import { getItemLocalStorage, selectAll } from "@utils/function";

/**
 * Set favorite player in draw/scroring
 */
export const MarkFavoritePlayers = () => {
  // get players from localstorage
  const getLocalStorage = getItemLocalStorage("HQfavoritePlayers");

  if (!getLocalStorage) return;

  const favoritePlayerOnMap = selectAll(".favorite-player-on-map");

  // remove all favorite player class
  favoritePlayerOnMap?.forEach((player) => {
    player.classList.remove("favorite-player-on-map");
  });

  if (getLocalStorage?.length <= 0) return;

  // add to array all favorite player
  const allFavoritePlayers = [];
  getLocalStorage.forEach((obj) => {
    allFavoritePlayers.push(obj);
  });

  const getAllDataIdPlayers = selectAll("[data-id-players]");
  // console.log("getAllDataIdPlayers", getAllDataIdPlayers.length);

  // set favorite player class, default is red #ff0000
  // https://tree.taiga.io/project/eventhubhq-eventhubclient/issue/71
  getAllDataIdPlayers.forEach((player, index) => {
    if (allFavoritePlayers.length <= 0) return;

    const arrayPlayers = player.dataset.idPlayers;

    const favoritePplayersArray = arrayPlayers.split(",");

    allFavoritePlayers.forEach((fav) => {
      if (favoritePplayersArray.includes(fav)) {
        getAllDataIdPlayers[index].classList.add("favorite-player-on-map");
      }
    });
  });
};
